module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/siren-on.svg?0398f0f1e92584d6d732a5fe1a4eb4fb";